import React from 'react';
import Avatar from '@material-ui/core/Avatar'
import Button from '@material-ui/core/Button';
import moment from 'moment'


const NotificationItem = ({notification}) => {
    const {wp_time, msg, status, status_type, license_plate, street} = notification;
    const icon = 'zmdi-calendar-note mdc-text-blue'
    const icon2 = status === 'expired' ? 'zmdi-alert-circle text-red':'zmdi-alert-triangle text-amber'
    return (
        <li className="media">
            <i className={`zmdi ${icon2} zmdi-hc-fw zmdi-hc-2x`}/>
            <div className="media-body align-self-center">
                <p className="sub-heading mb-0">{
                    msg
                }</p>
                <Button size="small" className="jr-btn jr-btn-xs mb-0"><i
                    className={`zmdi ${icon} zmdi-hc-fw`}/></Button> <span className="meta-date"><small>{moment(wp_time, 'YYYY-MM-DDTHH:mm:ssZ', true).format("YYYY-MM-DD HH:mm:ss")}</small></span>
            </div>
        </li>
    );
};

export default NotificationItem;



// WEBPACK FOOTER //
// ./components/AppNotificationLock/NotificationItem.js